<template>
  <LoadingWrapper :state="organizationLoadingStatus">
    <EditOrganizationGeneral :organization="organizationData" />
  </LoadingWrapper>
</template>
<script setup lang="ts">
  import LoadingWrapper from '../../../core/components/loading/LoadingWrapper.vue'
  import { useOrganization } from '../composables/useOrganization'
  import EditOrganizationGeneral from '../components/EditOrganizationGeneral.vue'

  const { data: organizationData, status: organizationLoadingStatus } = useOrganization()
</script>
